import { Navigate, Route, Routes } from "react-router-dom";
import { AppSidebar } from "@/components/AppSidebar";
import { AuthGate } from "@/components/LoginScreen";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import Settings from "@/pages/Settings";
import Agents from "@/pages/Agents";
import Events from "@/pages/Events";
import Runs from "@/pages/Runs";
import Sessions from "@/pages/Sessions";
import SessionChat from "@/pages/SessionChat";

export default function App() {
  return (
    <AuthGate>
      <div className="flex h-full min-h-screen">
        <AppSidebar />
        <main className="flex-1 overflow-y-auto bg-background">
          <div className="mx-auto w-full max-w-6xl px-6 py-8">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/agents" element={<Agents />} />
              <Route path="/events" element={<Events />} />
              <Route path="/sessions" element={<Sessions />} />
              <Route path="/sessions/:id" element={<SessionChat />} />
              <Route path="/runs" element={<Runs />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </AuthGate>
  );
}
